import { useTranslate } from "@similarweb/i18n-provider";
import { Button, IconButton } from "@similarweb/ui-components";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import intentTrackingService from "app/pages/sales-intelligence/services/tracking/intent/trackingService";
import { showIntentUpsellTopicHook } from "app/pages/sales-intelligence/sub-modules/intent/internalHooks/hooks";

export const IntentSignalTypeSectionAction = () => {
    const { translate } = useTranslate();
    const isIntentEnabled = salesSettingsHelper.isIntentSignalsEnabled();

    const handleManageClick = (): void => {
        void intentTrackingService.trackManageTopicsAction();
        void siNavigator.goToIntentSignalsManagementPage();
    };

    const handleUpgradeClick = (): void => {
        void intentTrackingService.trackUpgradeIntentAction();
        showIntentUpsellTopicHook();
    };

    if (isIntentEnabled) {
        return (
            <Button
                type="primary"
                dataAutomation="account-signals-intent-section-manage-button"
                onClick={handleManageClick}
            >
                {translate("si.intent.management.btn.manage-topics")}
            </Button>
        );
    }

    return (
        <IconButton
            iconName="sparkles"
            type="flatTrial"
            dataAutomation="account-signals-intent-section-upgrade-button"
            onClick={handleUpgradeClick}
        >
            {translate("si.intent.management.btn.upgrade")}
        </IconButton>
    );
};
